import React, { useEffect, useRef } from "react";

const Map = ({ center, zoom, children, style }) => {
  const ref = useRef(null);
  const [map, setMap] = React.useState();

  useEffect(() => {
    if (ref.current) {
      setMap(new window.google.maps.Map(ref.current, { center, zoom }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, center]);

  return (
    <>
      <div ref={ref} style={style} />
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          // set the map prop on the child component
          return React.cloneElement(child, { map });
        }
      })}
    </>
  );
};

export default Map;
